import React from "react";
import { Box } from "@mui/material";

const OnboardingProgress = ({ currentStep, visible = false }) => {
  const steps = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
  ];

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 40,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: "600px",
        px: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
        }}
      >
        {steps.map((step) => (
          <Box
            key={step.id}
            sx={{
              flex: 1,
              width: "100%",
              height: 2,
              backgroundColor: step.id <= currentStep ? "#fff" : "#333",
              transition: "background-color 0.3s ease",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default OnboardingProgress; 